import React from 'react';
import * as R from 'ramda';
import { useRouteError } from 'react-router';
// helpers/constants
import * as G from '../../helpers';
// ui
import { Box, Flex, MainActionButton } from '../../ui';
//////////////////////////////////////////////////

// TODO: check locale
export const RouteError = () => {
  const error = useRouteError();

  const { name, message = 'An unexpected error occurred.' } = R.or(error, {});

  const isChunkError = R.includes(
    name,
    [
      'Loading chunk',
      'ChunkLoadError',
      'dynamically imported module',
    ],
  );

  const errorMessage = isChunkError ?
    'A new version of the app may be available, but we couldn`t load it properly.' :
    message;

  return (
    <Flex
      width='100vw'
      height='100vh'
      flexDirection='column'
      justifyContent='center'
    >
      <Box fontSize={24} fontWeight='bold'>Something went wrong</Box>
      <Box my={10} maxWidth={800} fontSize={16} textAlign='justify' wordBreak='break-word'>
        {errorMessage}
      </Box>
      <MainActionButton onClick={() => G.windowLocationReload()}>
        Reload app
      </MainActionButton>
    </Flex>
  );
};
